/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ g: NonNullable<unknown> }} Confirm_Delete_GatewayInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this gateway \"{g}\"?" |
*
* @param {Confirm_Delete_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_gateway = /** @type {((inputs: Confirm_Delete_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Delete_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Are you sure you want to delete this gateway "${i?.g}"?`)
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette box “${i?.g}“ ?`)
});